module.exports = __webpack_public_path__ + "static/img/35-2.62804f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/35-2.jpg
// module id = /Frp
// module chunks = 0